export enum DictionaryType {
    DOCUMENT_TYPE = 'DOCUMENT_TYPE',
    GENDER = 'GENDER',
    LOCALITY_TYPE = 'LOCALITY_TYPE',
    NATIONALITY = 'NATIONALITY',
    PROPERTY_TYPE = 'PROPERTY_TYPE',

    CALCULATION_SUBJECT = 'CALCULATION_SUBJECT',

    NUMBER_OF_INSURED = 'NUMBER_OF_INSURED',
    FLOOD_CLAIMS = 'FLOOD_CLAIMS',
    VEHICLE_UNUSUAL_USAGE = 'VEHICLE_UNUSUAL_USAGE',

    INSTALLMENTS = 'INSTALLMENTS',
    DEFERRED_PAYMENT = 'DEFERRED_PAYMENT',

    VEHICLE_BODY_TYPE = 'VEHICLE_BODY_TYPE',
    VEHICLE_FUEL_TYPE = 'VEHICLE_FUEL_TYPE',
    VEHICLE_DOORS = 'VEHICLE_DOORS',
    VEHICLE_TYPE = 'VEHICLE_TYPE',

    CLAIM_SETTLEMENT_MODE = 'CLAIM_SETTLEMENT_MODE',

    OFFER_STATUS = 'OFFER_STATUS',
    CESSION_PARTY_TYPE = 'CESSION_PARTY_TYPE',

    COUNTRY = 'COUNTRY',
    FRONTIER_VEHICLE_CATEGORY = 'FRONTIER_VEHICLE_CATEGORY',
    PARTY_TYPE = 'PARTY_TYPE',
    INSURANCE_PERIOD = 'INSURANCE_PERIOD',

    PAYMENT_TYPE = 'PAYMENT_TYPE',
}

export enum CalculationSubject {
    CONTINUATION = 'CONTINUATION',
    NEW_POLICY = 'NEW_POLICY'
}

export enum PropertyType {
    HOUSE = 'HOUSE',
    FLAT = 'FLAT',
}

export enum DocumentStatus {
    OFFER = 'OFFER',
    CALCULATION = 'CALCULATION',
    IOFFER = 'IOFFER',
    CANCELLED = 'CANCELLED',
    DONE = 'DONE',
}

export class Dictionary {
    code: string = null;
    description: string = null;
    itemList: DictionaryItem[] = [];
}

export class DictionaryItem {
    code: string = null;
    description?: string = null;
    flexFilter1?: string[] = [];


    constructor(code: string = null, description: string = null) {
        this.code = code;
        this.description = description;
    }

    static getCode(item: DictionaryItem) {
        if (!item) {
            return null;
        }
        return item.code;
    }
}

export class DictionaryItemNumber {
    code: number = null;
    description?: string = null;

    constructor(code: number = null, description: string = null) {
        this.code = code;
        this.description = description;
    }

}
